const tab_class = () => import(/* webpackChunkName: "tabbar-class" */ '@/views/items/tabbar-class.vue');
const ItemSearch = () => import(/* webpackChunkName: "item-search" */ '@/views/items/search/');
const ItemSearchResult = () => import(/* webpackChunkName: "item-search" */ '@/views/items/search-result/');
const ItemList = () => import(/* webpackChunkName: "item-list" */ '@/views/items/list/');
const EsgList = () => import(/* webpackChunkName: "item-list" */ '@/views/items/esg/esg');
const ItemDetail = () => import( /* webpackChunkName: "item-detail" */ '@/views/items/detail/index');
const DiscountIndex = () => import( /* webpackChunkName: "discount-index" */ '@/views/items/discount/index');

const Tabbar = () => import(/* webpackChunkName: "Tabbar" */ '@/vue/components/Tabbar/');
const Appraise = () => import("@/views/items/detail/appraise-detail.vue");


export default [{
  path: "/items",
  name: "class",
  meta: {
    keepAlive: true
  },
  components: { default: tab_class, tabbar: Tabbar }
}, {
  path: "/items/search",
  name: "search",
  meta: {
    keepAlive: true
  },
  component: ItemSearch
}, {
  path: "/items/search/result",
  name: "search-result",
  meta: {
    keepAlive: true
  },
  component: ItemSearchResult,
  props: (route) => (route.query)
}, {
  path: "/items/detail/:itemId",
  name: "detail",
  props: true,
  component: ItemDetail
}, {
  path: "/items/list",
  name: "list",
  meta: {
    keepAlive: true
  },
  // component: ItemList,
  components: { default: ItemList, tabbar: Tabbar },
  props: (route) => ({
    category: +route.query.category,
    keyword: route.query.keyword
  })
}, {
  path: "/items/esg",
  name: "esg_zone",
  meta: {
    keepAlive: true
  },
  components: { default: EsgList, tabbar: Tabbar },
},
{
  path: "/discount/index",
  name: "discount-index",
  component: DiscountIndex
},
{
  path: "/items/appraise/:skuId",
  name: "appraise",
  component: Appraise
}
]
